module.exports = __webpack_public_path__ + "static/img/48e1f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/txgg_top.png
// module id = 650
// module chunks = 2